import { useEffect, useState } from "react";
import { InvoiceMetadataType } from "./InvoiceMetadataType";
import { InvoiceLine, KsefInvoice } from "./InvoiceType";
import SystemInvoiceItem from "./SystemInvoiceItem";
import { DemoFacturesType } from "./DemoFacturesType";
import { URL } from "../global";

export default function SystemInvoice({
  invoice,
  invoiceLoading,
  items,
  meta,
  customer,
  loadingCustomer,
  invoiceNumber,
  setInvoiceNumber,
  setUpdates,
  invoices,
  doneInvoices,
  setDoneInvoices,
}: {
  invoice: KsefInvoice;
  invoiceLoading: Boolean;
  items: InvoiceLine[];
  meta: InvoiceMetadataType | any;
  customer: any;
  loadingCustomer: Boolean;
  invoiceNumber: number;
  setInvoiceNumber: Function;
  setUpdates: Function;
  invoices: InvoiceMetadataType[];
  doneInvoices: any;
  setDoneInvoices: Function;
}) {
  const [values, setValues] = useState({
    currency: invoice?.Fa?.KodWaluty,
    saleDeadline: invoice?.Fa?.P_6,
    sourceDocumentNumber: invoice?.Fa?.P_2,
    sourceDocumentDate: invoice?.Fa?.P_1,
    sourceSaleDate: invoice?.Fa?.P_6,
    receivedDate: new Date(meta?.acquisitionDate)?.toISOString()?.slice(0, 10),
    paymentDueDate: String(
      invoice?.Fa?.Platnosc?.TerminPlatnosci?.at(0)?.Termin,
    ),
    sellerName: invoice?.Podmiot1?.DaneIdentyfikacyjne?.Nazwa,
    street: customer?.street,
    street_home_number: customer?.street_home_number,
    street_local_number: customer?.street_local_number,
    city: customer?.city,
    // post: customer?.post,
    postalCode: customer?.postal_code,
    nip: invoice?.Podmiot1?.DaneIdentyfikacyjne?.NIP,
    phone: customer?.phone || invoice?.Podmiot1?.DaneKontaktowe?.at(0)?.Telefon,
    email: customer?.email || invoice?.Podmiot1?.DaneKontaktowe?.at(0)?.Email,
    countFrom: undefined,
    warehouse: "",
    paymentType: "",
  });

  useEffect(() => {
    setValues((prev: any) => ({
      ...prev,
      currency: invoice?.Fa?.KodWaluty,
      //   saleDeadline: invoice?.Fa?.P_6,
      sourceDocumentNumber: invoice?.Fa?.P_2,
      sourceDocumentDate: invoice?.Fa?.P_1,
      sourceSaleDate: invoice?.Fa?.P_6,

      paymentDueDate:
        invoice?.Fa?.Platnosc?.TerminPlatnosci?.at(0)?.Termin &&
        new Date(String(invoice?.Fa?.Platnosc?.TerminPlatnosci?.at(0)?.Termin))
          ?.toISOString()
          ?.slice(0, 10),

      sellerName: invoice?.Podmiot1?.DaneIdentyfikacyjne?.Nazwa,
      street: customer?.street,
      street_home_number: customer?.street_home_number,
      street_local_number: customer?.street_local_number,
      city: customer?.city,
      // post: customer?.post,
      postalCode: customer?.postal_code,
      nip: invoice?.Podmiot1?.DaneIdentyfikacyjne?.NIP,
      phone:
        customer?.phone || invoice?.Podmiot1?.DaneKontaktowe?.at(0)?.Telefon,
      email: customer?.email || invoice?.Podmiot1?.DaneKontaktowe?.at(0)?.Email,
      countFrom: !items?.at(0)?.wartosc_netto ? "gross" : "net",
    }));
  }, [meta?.ksefNumber]);

  async function handleSubmit(e: any) {
    e.preventDefault();
    console.log(customer);
    const valuesToDB: DemoFacturesType = {
      net_value: meta?.netAmount,
      tax_value: meta?.vatAmount,
      gross_value: meta?.grossAmount,
      id_currencies: values?.currency === "PLN" ? 1 : 0,
      id_customers_seller: customer?.id,
      currencies_symbol: values?.currency,
      currencies_name: values?.currency === "PLN" ? "Złoty" : "",
      seller_street: values?.street,
      seller_city: values?.city,
      seller_street_home_number: values?.street_home_number,
      seller_street_local_number: values?.street_local_number,
      seller_email: values?.email,
      seller_phone: values?.phone,
      seller_postal_code: values?.postalCode,
      source_doc_date: values?.sourceDocumentDate,
      source_doc_date_sell: values?.sourceSaleDate,
      source_doc_name: values?.sourceDocumentNumber,
      seller_nip: values?.nip,
      seller_name: values?.sellerName,
      factures_types_only_netto: values?.countFrom === "net" ? true : false,
      factures_types_number_index:
        values?.warehouse === "BT"
          ? "G"
          : values?.warehouse === "H"
            ? "H"
            : values?.warehouse,
    };
    const result = await fetch(URL + "components/set/set-invoice.php", {
      credentials: "include",
      method: "POST",
      body: JSON.stringify(valuesToDB),
    });
    const response = await result.json();
    console.log(response, invoices?.length);
    if (response?.last_insert_id) {
      setInvoiceNumber((prev: number) => prev + 1);
      setUpdates((prev: number) => prev + 1);
      setDoneInvoices((prev: any) => {
        const n = [...prev];
        n[invoiceNumber] = true;
        return n;
      });
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="document-form grid">
        <fieldset>
          <legend>DANE DOKUMENTU</legend>

          <label>
            <span>Typ dokumentu</span>
            <span>FZ - Faktura zakupowa</span>
          </label>

          <label>
            <span>Waluta</span>
            <input
              type="text"
              name="currency"
              value={values.currency}
              disabled={true}
            />
          </label>

          <label
            style={
              values?.warehouse === ""
                ? { color: "brown" }
                : { fontWeight: "bold", color: "green" }
            }
          >
            <span>Magazyn</span>
            <select
              name="warehouse"
              value={values?.warehouse}
              onChange={(e) =>
                setValues((prev: any) => ({
                  ...prev,
                  warehouse: e.target.value,
                }))
              }
              required={true}
            >
              <option value="">— wybierz —</option>
              <option value="BT">BT – Biuro Tłumaczeń</option>
              <option value="H">H – Hotel</option>
            </select>
          </label>

          {/* <label>
            <span>Termin sprzedaży</span>
            <input
              type="date"
              name="saleDeadline"
              value={values.saleDeadline}
              disabled={true}
            />
          </label> */}

          <label>
            <span>Nr dokumentu źródłowego</span>
            <input
              type="text"
              name="sourceDocumentNumber"
              value={values.sourceDocumentNumber}
              disabled={true}
            />
          </label>

          <label>
            <span>Data dokumentu źródłowego</span>
            <input
              type="date"
              name="sourceDocumentDate"
              value={values?.sourceDocumentDate}
              disabled={true}
            />
          </label>

          <label>
            <span>Data sprzedaży dok. źródł.</span>
            <input
              type="date"
              name="sourceSaleDate"
              value={values?.sourceSaleDate}
              disabled={true}
            />
          </label>

          <label>
            <span>Data wpływu</span>
            <input
              type="date"
              name="receivedDate"
              value={values?.receivedDate}
              disabled={true}
            />
          </label>
          <label
            style={
              values?.paymentType === ""
                ? { color: "brown" }
                : { fontWeight: "bold", color: "green" }
            }
          >
            <span>Typ płatności</span>
            <select
              name="paymentType"
              onChange={(e) =>
                setValues((prev: any) => ({
                  ...prev,
                  paymentType: e.target.value,
                }))
              }
            >
              <option value="">— wybierz —</option>
              <option value="cash">Gotówka</option>
              <option value="card">Karta</option>
              <option value="transfer">Przelew</option>
            </select>
          </label>
          <label>
            <span>Termin płatności</span>
            <input
              type="date"
              name="paymentDueDate"
              value={values?.paymentDueDate}
            />
          </label>

          <label>
            <span>Licz od</span>
            <select name="countFrom" value={values?.countFrom} disabled={true}>
              <option value="gross">brutto</option>
              <option value="net">netto</option>
            </select>
          </label>
        </fieldset>

        <fieldset>
          <legend>SPRZEDAWCA</legend>
          <div>
            {invoiceLoading || loadingCustomer ? (
              <>Sprawdzanie klienta w bazie</>
            ) : customer?.id ? (
              <div color="green">✔ Pobrano z bazy</div>
            ) : (
              <>
                <div color="brown">Brak w bazie</div>
                <button>Dodaj do bazy</button>
              </>
            )}
          </div>
          <label>
            <span>Nazwa</span>
            <input type="text" name="sellerName" value={values?.sellerName} />
          </label>

          <label>
            <span>Ulica</span>
            <input type="text" name="street" value={values?.street} />
          </label>

          <label>
            <span>Numer domu</span>
            <input
              type="text"
              name="houseNumber"
              value={values?.street_home_number}
            />
          </label>

          <label>
            <span>Numer lokalu</span>
            <input
              type="text"
              name="apartmentNumber"
              value={values?.street_local_number}
            />
          </label>

          <label>
            <span>Miejscowość</span>
            <input type="text" name="city" value={values?.city} />
          </label>
          {/* 
          <label>
            <span>Poczta</span>
            <input
              type="text"
              name="postOffice"
              value={values?.post}
            />
          </label> */}

          <label>
            <span>Kod pocztowy</span>
            <input type="text" name="postalCode" value={values?.postalCode} />
          </label>

          <label>
            <span>NIP</span>
            <input type="text" name="nip" value={values?.nip} disabled={true} />
          </label>

          <label>
            <span>Telefon</span>
            <input type="tel" name="phone" value={values?.phone} />
          </label>

          <label>
            <span>E-mail</span>
            <input type="email" name="email" value={values?.email} />
          </label>
        </fieldset>
      </div>
      <div className="document-form">
        <fieldset>
          <legend>POZYCJE</legend>
          <table className="pretty-table">
            <thead>
              <tr>
                <th>Lp</th>
                {/* <th>Kod</th> */}
                <th>Nazwa</th>
                <th>J.m.</th>
                <th>Ilość</th>
                <th>Stawka VAT</th>
                {/* <th>Rabat</th> */}
                <th>Cena</th>
                <th>Wartość netto</th>
                <th>Wartość VAT</th>
                <th>Wartość brutto</th>
                <th>Uwagi</th>
              </tr>
            </thead>

            <tbody>
              {items?.length &&
                items?.map((item: InvoiceLine) => (
                  <SystemInvoiceItem item={item} />
                ))}
            </tbody>
          </table>
        </fieldset>
      </div>
      <div>
        <button
          onClick={() => {
            setInvoiceNumber((prev: number) => prev + 1);
            setUpdates((prev: number) => prev + 1);
          }}
        >
          Pomiń
        </button>
        <button type="submit">
          Dodaj do systemu{" "}
          {invoiceNumber === invoices?.length - 1 ? (
            <>i zamknij</>
          ) : (
            <>i przejdź do następnej</>
          )}
        </button>
      </div>
    </form>
  );
}
